import ApiExec, { ApiExecPublic } from '@utils/ApiExec';
import { encryptVars, DEBUG } from '@utils/global';

class CompromisoServices {
  createCompromisoPublic = (params) => {
    return ApiExecPublic(params, `app/compromisos/create-invito`, 'POST')
      .then((res) => res)
      .then((res) => res)
      .catch((error) => error);
  };

  validateINE = (values) => {
    const value = DEBUG ? values : encryptVars(values);
    return ApiExec({}, `compromisos/validate-existence/${value}`, 'GET')
      .then((res) => res)
      .then((res) => res)
      .catch((error) => error);
  };
}

const compromiso = new CompromisoServices();
export default compromiso;
